import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleH1 = styled.h1`
  font-family: "Cormorant Infant", sans-serif;
  color: #55749F;
  font-size: 132px;
  line-height: 76%;
  font-weight: 600;
  text-align: center;
  margin-bottom: 58px;
  
  span {
    color: #141414;
  }
  
  @media (max-width: 1439px) {
    font-size: 110px;
    margin-bottom: 48px;
  }
  
  @media (max-width: 979px) {
    font-size: 80px;
  }
  
  @media (max-width: 577px) {
    font-size: 70px;
    margin-bottom: 38px;
  }

  @media (max-width: 490px) {
    font-size: 50px;
    margin-bottom: 24px;
  }
`

export const Paragraph = styled.p`
  font-size: 22px;
  line-height: 140%;
  text-align: center;
  letter-spacing: -0.02em;
  max-width: 455px;
  margin: auto;

  @media (max-width: 1439px) {
    font-size: 20px;
  }

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const CustomParagraph = styled(Paragraph)`
  font-size: 18px;
  margin-bottom: 36px;
  max-width: 640px;

  @media (max-width: 979px) {
    margin-bottom: 40px;
  }
`

export const TabButtons = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  min-height: 50px;
  height: 50px;
  padding: 4px;
  justify-content: center;
  border: 1px solid #141414;
  border-radius: 60px;
  font-weight: 500;
  gap: 4px;
  margin-bottom: 55px;
  
  @media (max-width: 979px) {
    font-size: 16px;
  }
`

export const TabButton =styled.button<{isActive?: boolean}>`
  padding: 11px 20px;
  background-color: ${({ isActive }) => isActive ? "#BFDCF5" : ""};
  border-radius: 60px;
  min-height: 40px;
  height: 40px;
  box-sizing: border-box;
  line-height: 100%;
  transition: 0.2s;

  @media (max-width: 979px) {
    padding: 0 10px;
    white-space: nowrap;
  }
`

export const TabContent = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  
    .swiper-wrapper {
      padding-bottom: 30px;
    }
  
    .swiper-pagination-bullet {
      background-color: rgba(85, 116, 159, 1);
      width: 38px;
      height: 2px;
      border-radius: 0;
    }

    .swiper-pagination-bullet-active {
      background-color: #55749F;
      width: 38px;
      height: 2px;
      border-radius: 0;
    }
`

